import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-10758df1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"padding":"10px 16px 16px","height":"100%"}
}
const _hoisted_2 = {
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = { style: {"padding":"14px","width":"90%","box-sizing":"border-box"} }
const _hoisted_4 = { style: {"display":"flex","align-items":"center","justify-items":"space-between","margin-top":"16px","height":"16px"} }
const _hoisted_5 = { style: {"width":"100%","box-sizing":"border-box","margin-top":"20px"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "",
  style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%","padding-left":"10px","overflow":"hidden"}
}
const _hoisted_8 = {
  class: "cm-ellipsis-line-one gap-x-10",
  style: {"display":"flex","justify-content":"center","flex-direction":"column","flex":"0 1 auto"}
}
const _hoisted_9 = ["innerHTML", "title"]
const _hoisted_10 = {
  style: {"color":"var(--cm-color-text-secondary)","margin-top":"7px"},
  class: "cm-align-center gap-x-10"
}
const _hoisted_11 = {
  style: {"color":"var(--cm-color-text-secondary)"},
  class: "cm-ui-mr10"
}
const _hoisted_12 = {
  class: "",
  style: {"flex":"1 0 auto"}
}
const _hoisted_13 = {
  class: "",
  style: {"font-weight":"bold","text-align":"right"}
}
const _hoisted_14 = {
  class: "",
  style: {"color":"var(--cm-color-text-secondary)","text-align":"right","padding-top":"6px"}
}
const _hoisted_15 = ["innerHTML", "title"]
const _hoisted_16 = {
  class: "gap-x-5",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_17 = {
  key: 0,
  style: {"line-height":"2em","padding-left":"10px","font-size":"14px","position":"sticky","top":"0","z-index":"1"}
}
const _hoisted_18 = { style: {"font-weight":"bold","color":"var(--el-color-danger)"} }
const _hoisted_19 = { style: {"font-weight":"bold","color":"var(--el-color-danger)"} }
const _hoisted_20 = { class: "title cm-align-center" }
const _hoisted_21 = ["src"]

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import Describe from '../../ransomware-protection/components/Describe.vue';
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue';
import Keywords from './Keywords.vue';
import { GetSensitiveWordsOutgoingRecordResponseDataData, GetSensitiveWordsSensitiveFileInfoResponseDataData } from '../service';
import { formatTimeStamp } from '@/utils/time';
import { bytesToSize, highLightKeywords } from '@/utils/tool';
import { fileType, getApprovalChannelI18nKey, getApprovalChannelValue } from '../types/approval-terminal-file-outsourcing';
import { ControlResultState, ControlResultText } from '@/views/dashboard/manage/outbound-control-log';
type DescribeLs = {
  label: string, type?: string, valSpan?: number, show?: (info?: GetSensitiveWordsSensitiveFileInfoResponseDataData) => boolean,
  prop: keyof GetSensitiveWordsSensitiveFileInfoResponseDataData,
  labelSpan: number,
  formatter?: (val: string | number) => string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DataHistory',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  prev_id: { type: String, },
  id: {
    type: String,
    required: true
  },
  api: {
    type: Object,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const { t, locale } = useI18n()

const describeLs = computed((): DescribeLs[] => {
  void locale.value
  return [
    { label: t('dataHistory.fieldFileName'), prop: 'name', labelSpan: 4, valSpan: 19 },
    { label: t('dataHistory.fieldFileSize'), prop: 'size', labelSpan: 4, valSpan: 19, formatter: (val: string) => bytesToSize(~~val), show: () => false },
    { label: t('dataHistory.fieldFilePath'), prop: 'path', labelSpan: 4, valSpan: 19 },
    { label: t('dataHistory.fieldFileType'), prop: 'ext', labelSpan: 4, valSpan: 19 },
    { label: t('dataHistory.fieldSensitiveKeywords'), prop: 'keywords', labelSpan: 4, valSpan: 19 },
    { label: t('dataHistory.fieldCreateTime'), prop: 'create_time', labelSpan: 4, valSpan: 19, formatter: (val) => formatTimeStamp(val, 'YYYY-MM-DD HH:mm'), show: () => !!props.prev_id },
    { label: t('dataHistory.fieldUpdateTime'), prop: 'update_time', labelSpan: 4, valSpan: 19, formatter: (val) => formatTimeStamp(val, 'YYYY-MM-DD HH:mm'), show: () => !props.prev_id },
  ]
})

/** 英文「数字 + 单位」语序；中日台为「前缀 + 数字 + 后缀」 */
const outboundTotalCountFirst = computed(() => {
  void locale.value
  return locale.value === 'en-US'
})

const dataHistoryDrawerTitle = computed(() => {
  void locale.value
  return t('sensitiveFileScanning.dataHistoryDrawerTitle', { name: fileInfo.value.name || '--' })
})

const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emits('update:modelValue', val)
  }
})
const getSvgPath = (softName: string) => {
  const value = getApprovalChannelValue(softName)
  return value ? getSvgIconDataUrl(`views/dashboard/data-safe/anti-external-control/assets/approvalType/${value}`) : ''
}

function outboundChannelLabel(softName: string) {
  const key = getApprovalChannelI18nKey(softName)
  return key ? t(key) : softName
}
const activeName = ref('baseInfo')
const activeNameCollapse = ref(['base_info', 'out_records'])
const loading = ref(true)
const fileInfo = ref({} as GetSensitiveWordsSensitiveFileInfoResponseDataData)
const historyData = ref([] as GetSensitiveWordsOutgoingRecordResponseDataData[])
const getDataInfo = async (nv: string) => {
  let timer = null;
  // 获取外发记录和文件信息
  const infoResult = await props.api.fileInfoApi(nv).catch(err => { return { data: {} } })
  fileInfo.value = {} as GetSensitiveWordsSensitiveFileInfoResponseDataData
  fileInfo.value = infoResult.data || {}
  const recordResult = await props.api.recordApi(nv, typeof props.prev_id === 'undefined' ? 1 : 0).catch(err => ({ data: [] }))
  historyData.value = [] as GetSensitiveWordsOutgoingRecordResponseDataData[]
  historyData.value = recordResult.data
  timer = setTimeout(() => {
    clearTimeout(timer)
    loading.value = false
  }, 200)

}

function getApprovalImgName(activity: GetSensitiveWordsOutgoingRecordResponseDataData) {
  return getApprovalChannelValue(activity.soft_name)
}

watch(() => props.id, (nv, ov) => {
  loading.value = true
  if (props.modelValue && nv !== ov) {
    activeName.value = 'baseInfo'
    activeNameCollapse.value = ['base_info', 'out_records']
    // 获取外发记录和文件信息
    getDataInfo(nv)
  }
}, {
  immediate: true,
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: dataHistoryDrawerTitle.value,
    size: "650px",
    direction: "rtl"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_skeleton, {
          style: {"width":"100%"},
          loading: loading.value,
          animated: ""
        }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_skeleton_item, {
                variant: "image",
                style: {"width":"64px","height":"64px","padding":"20px"}
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_skeleton_item, {
                  variant: "h3",
                  style: {"flex":"1"}
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"margin-right":"16px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"width":"30%"}
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_skeleton_item, {
                variant: "h3",
                style: {"flex":"1"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"margin-right":"16px","margin-top":"30px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"60%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"55%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"75%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"65%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"55%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"45%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"45%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"45%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"45%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"30%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"30%","margin-top":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"45%","margin-top":"16px"}
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                return _createVNode(_component_el_skeleton_item, {
                  variant: "text",
                  style: {"width":"100%","margin-top":"16px"},
                  key: i
                })
              }), 64))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(TerminalHead, {
              "system-type": 4,
              "login-status": 1
            }, {
              logo: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(fileType).includes(fileInfo.value.ext) ? _unref(getSvgIconDataUrl)(`views/dashboard/data-safe/anti-external-control/assets/fileType/${fileInfo.value.ext}`) : require(`../assets/file.png`),
                  width: "80",
                  height: "80",
                  alt: ""
                }, null, 8, _hoisted_6)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      innerHTML: _unref(highLightKeywords)(fileInfo.value.name, fileInfo.value.keywords + ''),
                      style: {"font-weight":"bold","font-size":"18px"},
                      class: "cm-ellipsis-line-one",
                      title: fileInfo.value.name
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('dataHistory.matchedSensitiveWords')), 1),
                      _createVNode(Keywords, {
                        keywords: fileInfo.value.keywords,
                        "max-count": 6
                      }, null, 8, ["keywords"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(fileInfo.value.user_mark), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(fileInfo.value.group_name), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse, {
              modelValue: activeNameCollapse.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNameCollapse).value = $event)),
              style: {"margin-top":"15px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, {
                  title: _ctx.$t('dataHistory.collapseBasicInfo'),
                  name: "base_info"
                }, {
                  default: _withCtx(() => [
                    (Object.keys(fileInfo.value).length)
                      ? (_openBlock(), _createBlock(Describe, {
                          key: 0,
                          detailInfoObj: fileInfo.value,
                          rowStyle: { 'margin-bottom': '10px', 'margin-left': '10px' },
                          describeList: describeLs.value,
                          type: "source"
                        }, {
                          keywords: _withCtx(({ value }) => [
                            _createVNode(Keywords, {
                              style: {"height":"100%"},
                              keywords: value,
                              "max-count": 30
                            }, null, 8, ["keywords"])
                          ]),
                          name: _withCtx(({ value }) => [
                            _createElementVNode("div", {
                              innerHTML: _unref(highLightKeywords)(value, fileInfo.value.keywords + ''),
                              class: "cm-ellipsis-line-one cm-align-center",
                              style: {"height":"100%"},
                              title: fileInfo.value.name
                            }, null, 8, _hoisted_15)
                          ]),
                          _: 1
                        }, 8, ["detailInfoObj", "describeList"]))
                      : (_openBlock(), _createBlock(_component_el_empty, {
                          key: 1,
                          style: {"margin-top":"20vh"},
                          "image-size": 250,
                          image: _unref(getSvgIconDataUrl)(_ctx.EMPTY_TABLE_SVG_ICON),
                          description: _ctx.$t('dataHistory.emptyDescription')
                        }, null, 8, ["image", "description"]))
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_el_collapse_item, { name: "out_records" }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.$t('dataHistory.collapseOutboundRecords')) + " ", 1),
                      (historyData.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (outboundTotalCountFirst.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(historyData.value.length), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('dataHistory.outboundTotalSuffix')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('dataHistory.outboundTotalPrefix')), 1),
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(historyData.value.length), 1),
                                  _createTextVNode(_toDisplayString(_ctx.$t('dataHistory.outboundTotalSuffix')), 1)
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "",
                      style: _normalizeStyle(`max-height:calc(100vh - ${activeNameCollapse.value.includes('base_info') ? '560px' : '360px'});overflow: auto;padding-top: 10px;`)
                    }, [
                      (historyData.value.length)
                        ? (_openBlock(), _createBlock(_component_el_timeline, {
                            key: 0,
                            style: {"height":"100%","padding":"10px 0 0 10px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyData.value, (activity, index) => {
                                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                  hollow: true,
                                  icon: "cc",
                                  color: "var(--cm-color-primary)",
                                  key: activity.id,
                                  placement: "top",
                                  timestamp: _unref(formatTimeStamp)(activity.create_time, 'YYYY-MM-DD HH:mm')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_card, {
                                      shadow: "never",
                                      bodyStyle: "padding: 12px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_20, [
                                          (getSvgPath(activity.soft_name))
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                height: "20",
                                                alt: "",
                                                class: "cm-ui-mr10",
                                                style: {"object-fit":"cover"},
                                                src: getSvgPath(activity.soft_name)
                                              }, null, 8, _hoisted_21))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('dataHistory.outboundTimelineTitle', { channel: outboundChannelLabel(activity.soft_name), process: activity.process_name || '' })) + " ", 1),
                                          _createVNode(_component_el_tag, {
                                            type: _unref(ControlResultState).Blocked === activity.control_result ? 'danger' : 'primary',
                                            style: {"margin-left":"auto"},
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(ControlResultText)[activity.control_result ||
                              1]), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["type"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["timestamp"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_empty, {
                            key: 1,
                            style: {"margin-top":"1vh"},
                            "image-size": 250,
                            image: _unref(getSvgIconDataUrl)(_ctx.EMPTY_TABLE_SVG_ICON),
                            description: _ctx.$t('dataHistory.emptyDescription')
                          }, null, 8, ["image", "description"]))
                    ], 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})